import {
    Component, EventEmitter, Input, Output,
} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {DxSelectBoxModule, DxTextBoxModule, DxValidatorComponent} from 'devextreme-angular';
import * as AspNetData from "devextreme-aspnet-data-nojquery";
import {ValidationRule} from "devextreme-angular/common";
import {EmployeeDto} from "@services";

@Component({
    selector: 'pictured-item-select-box',
    templateUrl: 'pictured-item-select-box.component.html',
    styleUrls: ['./pictured-item-select-box.component.scss'],
    imports: [
        DxSelectBoxModule,
        DxTextBoxModule,
        CommonModule,
        NgOptimizedImage,
        DxValidatorComponent
    ],
})
export class PicturedItemSelectBoxComponent {
    @Input() value: string | undefined;
    @Input() label = '';
    @Output() valueChange = new EventEmitter<string>();
    @Input() dataSource: AspNetData.CustomStore
    @Input() validators: ValidationRule[] = [{type: 'required'}];
    @Input() readOnly: boolean;

    getData = (data: EmployeeDto)=> data;

}
